import { render, staticRenderFns } from "./AssessmentReportDDS.vue?vue&type=template&id=828c84ac&scoped=true"
import script from "./AssessmentReportDDS.vue?vue&type=script&lang=js"
export * from "./AssessmentReportDDS.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReportDDS.vue?vue&type=style&index=0&id=828c84ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828c84ac",
  null
  
)

export default component.exports